import * as React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import * as rsuite from "rsuite";
import "rsuite/dist/rsuite-rtl.min.css";
// import { trackPromise } from "react-promise-tracker";
// import * as ReactDOM from 'react-router-dom';
// import { Modal } from "react-bootstrap";
// import axios from "axios";
import * as General from "../Business/General/General.js";
// import AnimatedNavbar from "./AnimatedNavbar.js"
// import MobNavbar from "./MobNavbar.js"
// import { isBrowser } from 'react-device-detect';
import UserProperty from "./UserProperty.js"

import styled from "styled-components"
import "./Style.css"
import { ReactSocialMediaIcons } from 'react-social-media-icons';
import { Helmet } from "react-helmet";

const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "فارم آسان",
    "alternateName": [
        "فارم اسان",
        "FarmAsan",
        "Farm Asan"
    ],
    "url": "https://farmasan.ir",
    "logo": "https://farmasan.ir/assets/images/Logo.png",
    "description": "بازرگانی فارم آسان؛ عرضه‌کننده انواع تجهیزات کشاورزی، موتور برق، پمپ، کارواش، سمپاش و ابزار صنعتی.",
    "telephone": "+987132221005",
    "contactPoint": [
        {
            "@type": "ContactPoint",
            "telephone": [
                "+987132221005",
                "+987132221143"
            ],
            "contactType": "sales",
            "areaServed": "IR",
            "availableLanguage": ["fa", "en"]
        },
        {
            "@type": "ContactPoint",
            "telephone": "+989101172004",
            "contactType": "sales",
            "areaServed": "IR",
            "availableLanguage": ["fa", "en"]
        },
        {
            "@type": "ContactPoint",
            "telephone": "+989357105608",
            "contactType": "customer service",
            "areaServed": "IR",
            "availableLanguage": ["fa", "en"]
        }
    ],
    "address": {
        "@type": "PostalAddress",
        "streetAddress": " شیراز - خیابان سعدی - پاساژ ملت - نبش خیابان فردوسی - فروشگاه مهران (فارم آسان)",
        "addressLocality": "شیراز",
        "addressCountry": "IR"
    },
    "sameAs": [
        "https://maps.app.goo.gl/1vqVsQ67XDTQKxSF9",
        "https://wa.me/+989101172004",
        "https://www.instagram.com/farm.asan?igsh=Nzd5d3dyNWY2MzJz"
    ]
};

const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "فارم آسان",
    "alternateName": [
        "FarmAsan",
        "Farm Asan"
    ],
    "url": "https://farmasan.ir/"
};





const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;

`

const FooterContainer = styled.div`
  background-size: cover;
  background-color: #c4392f;
  display: flex;
  flex-direction: column;
  min-height: 50vh;
  > div:first-of-type {
    flex: 1 0 50vh;
  }
`



const CustomerLayout = ({ title, headers, children, className }) => {

    const GoToHome = () => {
        window.location.href = '/'
    }

    React.useEffect(() => {

    }, []);


    return (
        <rsuite.Container >

            <Helmet>
                {/* <title>فروشگاه فارم آسان | تجهیزات کشاورزی و صنعتی</title>
                            <meta
                                name="description"
                                content="بازرگانی فارم آسان؛ عرضه‌کننده انواع تجهیزات کشاورزی، موتور برق، پمپ، کارواش، سمپاش و ابزار صنعتی در شیراز."
                            /> */}
                <script type="application/ld+json">
                    {JSON.stringify(organizationSchema)}
                </script>

                <script type="application/ld+json">
                    {JSON.stringify(websiteSchema)}
                </script>
            </Helmet >
            <rsuite.Grid fluid className="bg-white mb-0  w-100p">

                <rsuite.Row>
                    <rsuite.Col className="m-0" xs={24} sm={24}>
                        {headers}
                    </rsuite.Col>
                    <rsuite.Col className={"m-0 " + className} xsHidden md={8}>
                        <div className='CustomerBanner'
                            style={{
                                background: `linear-gradient(90deg, rgba(47,72,88,1) 15%, rgba(76,114,139,1) 37%, rgba(251,250,250,1) 67%)`
                            }}
                        >
                        </div>
                        <h1 className="CustomerBanner-text ">
                            {title}
                        </h1>

                    </rsuite.Col>
                    <rsuite.Col xs={24} sm={24} md={className == 'hide' ? 24 : 16} className="m-0 h-90vh">
                        <h1 className="m-0 ProductInfoAddressBar">
                            <rsuite.Breadcrumb>
                                <rsuite.Breadcrumb.Item className="Cursor" onClick={() => GoToHome()}>
                                    خانه
                                </rsuite.Breadcrumb.Item>
                                <rsuite.Breadcrumb.Item>
                                    <UserProperty></UserProperty>

                                </rsuite.Breadcrumb.Item>
                                <rsuite.Breadcrumb.Item style={{ color: '#3b6682' }}>  {title} </rsuite.Breadcrumb.Item>
                            </rsuite.Breadcrumb>



                        </h1>
                        {children}

                    </rsuite.Col>
                </rsuite.Row>

                <rsuite.Row className=" border-top border-5" style={{ "backgroundColor": "#b52c0b" }} >
                    <rsuite.Grid fluid className="p-3 ">
                        <rsuite.Col xs={24} md={12} className="Font11  mt-2" style={{ color: "#ffff" }}>
                            شیراز - خیابان سعدی - پاساژ ملت - نبش خیابان فردوسی - فروشگاه مهران (فارم آسان)
                            <br />
                            <ReactSocialMediaIcons className='pe-2 ps-2' borderColor="rgb(251, 251, 252, 0.0)" icon="instagram"
                                iconColor="#ffff" backgroundColor="rgb(251, 251, 252, 0.0)"
                                url="https://www.instagram.com/farm.asan?igsh=Nzd5d3dyNWY2MzJz" size="30" />

                            <ReactSocialMediaIcons className='pe-2 ps-2' borderColor="rgb(251, 251, 252, 0.0)" icon="whatsapp"
                                iconColor="#ffff" backgroundColor="rgb(251, 251, 252, 0.0)"
                                url="https://wa.me/+989101172004" size="30" />

                            <ReactSocialMediaIcons className='pe-2 ps-2' borderColor="rgb(251, 251, 252, 0.0)" icon="map"
                                iconColor="#ffff" backgroundColor="rgb(251, 251, 252, 0.0)"
                                url="https://maps.app.goo.gl/1vqVsQ67XDTQKxSF9" size="30" />

                            <ReactSocialMediaIcons className='pe-2 ps-2' borderColor="rgb(251, 251, 252, 0.0)" icon="mail"
                                iconColor="#ffff" backgroundColor="rgb(251, 251, 252, 0.0)"
                                url="https://mail.google.com/mail/?view=cm&fs=1&to=Asma.dehghani@gmail.com" size="30" />

                        </rsuite.Col>
                        <rsuite.Col xs={24} md={12} className="text-left">
                            <a referrerpolicy='origin' target='_blank'
                                href='https://trustseal.enamad.ir/?id=603884&Code=hP2KKVOpE2ojv5Hqn7Pzunw4FSbPbmyh'>
                                <img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=603884&Code=hP2KKVOpE2ojv5Hqn7Pzunw4FSbPbmyh' alt=''
                                    style={{ cursor: 'pointer', width: '70px' }} code='hP2KKVOpE2ojv5Hqn7Pzunw4FSbPbmyh' /></a>
                        </rsuite.Col>


                    </rsuite.Grid>
                </rsuite.Row>


            </rsuite.Grid>
        </rsuite.Container>




    );
};

export default CustomerLayout;